import React, { useState, useEffect } from 'react';
import './App.css';
import { auth } from './firebase';
import {
  GoogleAuthProvider,
  signInWithPopup,
  signInWithEmailAndPassword,
  createUserWithEmailAndPassword,
  onAuthStateChanged,
  signOut,
  User,
} from 'firebase/auth';
import StarterPrompt from './StarterPrompt';

function App() {
  const [user, setUser] = useState<User | null>(null);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isRegister, setIsRegister] = useState(false);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, setUser);
    return () => unsubscribe();
  }, []);

  const handleGoogleSignIn = async () => {
    setError('');
    try {
      const provider = new GoogleAuthProvider();
      await signInWithPopup(auth, provider);
    } catch (err: any) {
      setError(err.message);
    }
  };

  const handleEmailSignIn = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    try {
      if (isRegister) {
        await createUserWithEmailAndPassword(auth, email, password);
      } else {
        await signInWithEmailAndPassword(auth, email, password);
      }
    } catch (err: any) {
      setError(err.message);
    }
  };

  const handleSignOut = async () => {
    await signOut(auth);
  };

  return (
    <div className="landing-container">
      {user && (
        <header className="main-header">
          <div className="main-header__brand">LearningPaths</div>
          <button className="main-header__signout" onClick={handleSignOut}>Sign Out</button>
        </header>
      )}
      <main className="landing-content">
        {!user ? (
          <div className="auth-card">
            <h1 className="auth-title">Welcome to <span>LearningPaths</span></h1>
            <p className="auth-subtitle">Your journey to knowledge starts here.</p>
            <button className="google-btn" onClick={handleGoogleSignIn}>
              <span className="google-icon" aria-hidden> 
                <svg width="22" height="22" viewBox="0 0 48 48"><g><path fill="#4285F4" d="M44.5 20H24v8.5h11.7C34.7 33.1 30.1 36 24 36c-6.6 0-12-5.4-12-12s5.4-12 12-12c2.7 0 5.2.9 7.2 2.4l6.4-6.4C33.5 5.1 28.1 3 24 3 12.4 3 3 12.4 3 24s9.4 21 21 21c10.5 0 20-7.5 20-21 0-1.3-.1-2.7-.5-4z"/><path fill="#34A853" d="M6.3 14.7l7 5.1C15.1 16.2 19.2 13 24 13c2.7 0 5.2.9 7.2 2.4l6.4-6.4C33.5 5.1 28.1 3 24 3 15.6 3 8.1 8.5 6.3 14.7z"/><path fill="#FBBC05" d="M24 45c6.1 0 11.2-2 14.9-5.4l-6.9-5.7C29.7 35.7 27 36.7 24 36.7c-6.1 0-11.3-4.1-13.2-9.7l-7 5.4C8.1 39.5 15.6 45 24 45z"/><path fill="#EA4335" d="M44.5 20H24v8.5h11.7c-1.2 3.2-4.2 5.5-7.7 5.5-4.6 0-8.3-3.7-8.3-8.3s3.7-8.3 8.3-8.3c1.3 0 2.5.3 3.5.8l6.6-6.6C36.2 7.6 30.4 5 24 5c-9.9 0-18 8.1-18 18s8.1 18 18 18c8.8 0 16.2-6.2 17.8-14.5.1-.5.2-1 .2-1.5z"/></g></svg>
              </span>
              <span>Sign in with Google</span>
            </button>
            <div className="divider"><span>or</span></div>
            <form className="auth-form" onSubmit={handleEmailSignIn}>
              <input
                type="email"
                placeholder="Email address"
                value={email}
                onChange={e => setEmail(e.target.value)}
                required
                autoComplete="username"
              />
              <input
                type="password"
                placeholder="Password"
                value={password}
                onChange={e => setPassword(e.target.value)}
                required
                autoComplete={isRegister ? "new-password" : "current-password"}
              />
              <button className="cta-button" type="submit">
                {isRegister ? 'Create Account' : 'Sign in'}
              </button>
            </form>
            <button className="toggle-auth" onClick={() => setIsRegister(r => !r)}>
              {isRegister ? 'Already have an account? Sign in' : "Don't have an account? Register"}
            </button>
            {error && <div className="auth-error">{error}</div>}
          </div>
        ) : (
              <StarterPrompt />
        )}
      </main>
      <footer className="landing-footer">
        &copy; {new Date().getFullYear()} LearningPaths
      </footer>
    </div>
  );
}

export default App;
